















































import _ from 'lodash';
import { editFactory } from '@/main/pages';
import { insertFromPosition } from '@/main/utils/stringHelper';

// eslint-disable-next-line no-unused-vars
import { store, EmailDynText as EmailDynTextType } from './store/edit';
import { NAME } from './constants';

export default editFactory(NAME, store).extend({
	data() {
		return {
			EmailPredmetCaretPosition: 0,
			EmailTextCaretPosition: 0,
		};
	},
	computed: {
		localizeCharCount() {
			return this.LocalizePopisostatni('CharCount');
		},
		emailTextLength() {
			return this.Emailtext ? this.Emailtext.length : 0;
		},
		emailDynTextListCmp() {
			const EmailDynTextListFiltered = this.EmailDynTextList?.filter((item) => item.EmailTypPzn === this.EmailTypPzn) || [];
			return _.map(EmailDynTextListFiltered, (item) => ({ Text: item.Text, Value: item.ZaznamId }));
		},
		emailDynTextItem() : EmailDynTextType | null {
			if (this.EmailDynTextId) {
				return this.EmailDynTextList?.find((item) => item.ZaznamId === this.EmailDynTextId) || null;
			}
			return null;
		},
	},
	watch: {
		EmailTypPzn() {
			this.EmailDynTextId = null;
		},
	},
	methods: {
		setDefault() {
			const defaultTemplate = this.EmailTextRefList?.find((item) => item.EmailTypPzn === this.EmailTypPzn);
			this.Emailpredmet = defaultTemplate?.EmailPredmet || null;
			this.Emailtext = defaultTemplate?.EmailText || null;
			this.PodpisText = defaultTemplate?.PodpisText || null;
		},
		addToPredmet() {
			this.Emailpredmet = insertFromPosition(this.Emailpredmet, this.emailDynTextItem?.DynZnac || '', this.EmailPredmetCaretPosition);
		},
		addToText() {
			this.Emailtext = insertFromPosition(this.Emailtext, this.emailDynTextItem?.DynZnac || '', this.EmailTextCaretPosition);
		},
		updateEmailPredmetCaretPosition(event: UIEvent) {
			this.EmailPredmetCaretPosition = (event?.target as HTMLInputElement)?.selectionStart || 0;
		},
		updateEmailTextCaretPosition(event: UIEvent) {
			this.EmailTextCaretPosition = (event?.target as HTMLInputElement)?.selectionStart || 0;
		},
	},
});
